import { useContext, useMemo, useState } from "react";
import laptopLogo from "../../assets/laptop.png";
import { Card, CardActionArea, CardContent, CircularProgress, Typography } from "@mui/material";
import { getUserCourse } from "../../facades/UserFacade";
import { UserContext } from "../../contexts/userContext";
import UserCourse from "../entities/UserCourse";
import { useNavigate } from "react-router-dom";
import useLiveLogging from "../../hooks/useLiveLogging";
import GenericDialog from "../dialogs/GenericDialog";
import Config from "../entities/Config";


export default function StudySkillsCard({ courseIds, studyEssentials }) {
    const [showPopup, setShowPopup] = useState(false);
    const userContext = useContext(UserContext);
    const navigate = useNavigate();
    const candidateAction = useLiveLogging();
    const courses = userContext.user.courses
    const userCourse = useMemo(() => {
        let se_index = courseIds?.indexOf(studyEssentials)
        if (se_index >= 0)
            getUserCourse(courseIds[se_index], userContext.user)
                .then(res => res.json())
                .then(uc => {
                    //setUserCourse(new UserCourse(uc))
                    return new UserCourse(uc)
                })
    }, [courseIds, studyEssentials, userContext])

    const toggleDialog = () => {
        setShowPopup(!showPopup);
    }

    const goToStudySkillsPage = () => {
        candidateAction({
            component: "EasyAccessRow",
            event: "User Clicked the Study skills card",
        });
        let unit = Config.STUDY_ESSENTIALS_UNIT;
         navigate(`${process.env.REACT_APP_AB_URL_PREFIX}/info/study-skills`, { state: { unit: unit, course: userCourse, courseIds: courses } });
        
        /*        
        if (userCourse == null)
            toggleDialog();
        else {
            if (userCourse !== null) {
                let unit = userCourse.getStudySkillsUnit()
                navigate(`${process.env.REACT_APP_AB_URL_PREFIX}/info/study-skills`, { state: { unit: unit, course: userCourse, courseIds: courses } });
            }
        }*/
    }

    return <>
        <Card sx={{ mb: 3, borderRadius: 5 }}>
            <CardActionArea onClick={(e) => goToStudySkillsPage()}>
                <CardContent>
                    <img src={laptopLogo} alt="" />
                    <Typography
                        sx={{ height: "50px" }}
                        gutterBottom
                        variant="h5"
                        component="h2"
                    >
                        Study Skills
                        {userCourse === null && <CircularProgress />}
                    </Typography>

                    <Typography
                        sx={{ height: "20px", fontSize: "11pt" }}
                        color="textSecondary"
                        component="p"
                    >
                        Study Essentials | Bootcamp | Exam Prep
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
        <GenericDialog title="Study Essentials not Available" text="The Study Essentials materials are not currently available. Please check back later." toggleDialog={toggleDialog} showDialog={showPopup} />
    </>
}